import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/user';

export default {
  // get() {
  //     return axiosWdw.get(endpoint);
  // },

  // getItem(id: number) {
  //     return axiosWdw.get(endpoint+'/'+id);
  // },

  getSelf(params: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/self',
        params: params,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  putPassword(id: number, pData: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint + '/' + id + '/change_password',
        data: pData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  putProfile(id: number, pData: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint + '/' + id + '/edit',
        data: pData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  putAvatar(id: number, pData: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint + '/' + id + '/change_avatar',
        data: pData,
        headers: { 'Content-Type': 'multipart/form-data' },
        // Axios somehow transformed FormData into JSON object, which will not work for image uploads
        // So we used transformRequest that simply returns the original data
        transformRequest: data => data,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  putDelete(id: number, pData: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint + '/' + id + '/delete',
        data: pData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  putToggleReceiveProjectEmails(id: number, toggle: boolean) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint + '/' + id + '/toggle_receive_project_emails?toggle=' + (toggle ? 1 : 0),
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
